import type { CatalogCategory, CatalogModel, CatalogProvider } from '@/types/catalog'

export const MOCK_CATEGORIES: CatalogCategory[] = [
  { id: 'cat-general', name: 'General Chat', slug: 'general-chat' },
  { id: 'cat-coding', name: 'Coding', slug: 'coding' },
  { id: 'cat-engineering', name: 'Engineering', slug: 'engineering' },
  { id: 'cat-business', name: 'Business', slug: 'business' },
  { id: 'cat-research', name: 'Research', slug: 'research' },
  { id: 'cat-image', name: 'Image', slug: 'image' },
  { id: 'cat-audio', name: 'Audio', slug: 'audio' },
  { id: 'cat-agents', name: 'Agents', slug: 'agents' },
]

export const MOCK_PROVIDERS: CatalogProvider[] = [
  { id: 'prov-openrouter', name: 'OpenRouter' },
  { id: 'prov-anthropic', name: 'Anthropic' },
  { id: 'prov-openai', name: 'OpenAI' },
  { id: 'prov-google', name: 'Google' },
  { id: 'prov-meta', name: 'Meta' },
]

export const RATED_DEMO_MODEL: CatalogModel = {
  id: 'model-rated-demo',
  categoryId: 'cat-coding',
  providerId: 'prov-openrouter',
  providerName: 'OpenRouter',
  displayName: 'GPT-4o',
  slug: 'gpt-4o',
  description: 'Demo model for compare rating E2E — user score updates from ratings.',
  contextWindow: 128_000,
  pricing: { inputPerMillion: 2.5, outputPerMillion: 10, isFree: false },
  status: 'active',
  isPinned: false,
  categoryScore: 0.72,
  userScore: 0,
  features: { toolCalling: true, vision: true, streaming: true },
}

const MODEL_PREFIXES = ['GPT', 'Claude', 'Gemini', 'Llama', 'DeepSeek', 'Mistral', 'Qwen', 'Phi']
const MODEL_SUFFIXES = ['Mini', 'Pro', 'Ultra', 'Coder', 'Instruct', 'Turbo', 'Flash', 'Max']

export function generateMockModels(count = 500): CatalogModel[] {
  const models: CatalogModel[] = []

  for (let index = 0; index < count; index += 1) {
    const category = MOCK_CATEGORIES[index % MOCK_CATEGORIES.length]
    const provider = MOCK_PROVIDERS[index % MOCK_PROVIDERS.length]
    const prefix = MODEL_PREFIXES[index % MODEL_PREFIXES.length]
    const suffix = MODEL_SUFFIXES[(index + 3) % MODEL_SUFFIXES.length]
    const variant = Math.floor(index / MODEL_PREFIXES.length) + 1
    const displayName = `${prefix} ${suffix} ${variant}`
    const isFree = index % 11 === 0
    const statusRoll = index % 17

    let status: CatalogModel['status'] = 'active'
    if (statusRoll === 0) status = 'archived'
    if (statusRoll === 1) status = 'hidden'

    const inputPrice = isFree ? 0 : Number((((index % 50) + 1) * 0.1).toFixed(2))
    const outputPrice = isFree ? 0 : Number((((index % 40) + 2) * 0.2).toFixed(2))

    models.push({
      id: `model-${index + 1}`,
      categoryId: category.id,
      providerId: provider.id,
      providerName: provider.name,
      displayName,
      slug: displayName.toLowerCase().replace(/\s+/g, '-'),
      description: `${displayName} is a ${category.name.toLowerCase()} model from ${provider.name}.`,
      contextWindow: 32_000 + (index % 8) * 16_000,
      pricing: {
        inputPerMillion: inputPrice,
        outputPerMillion: outputPrice,
        isFree,
      },
      status,
      isPinned: index % 23 === 0,
      categoryScore: Number((0.55 + (index % 45) / 100).toFixed(3)),
      userScore: Number((0.4 + (index % 60) / 100).toFixed(3)),
      features: {
        toolCalling: index % 3 !== 0,
        vision: index % 4 === 0,
        streaming: true,
      },
    })
  }

  return models
}

export const MOCK_MODELS = [RATED_DEMO_MODEL, ...generateMockModels(500)]
